(function () {
  'use strict';

  var COLOR_MAP = {
    'brown': '#6F4E37',
    'plum purple': '#7D3C6E',
    'eden green': '#2E5940',
    'apricot': '#FBCEB1',
    'black': '#1A1A1A',
    'navy blue': '#1B2A4A',
    'coffee': '#4B3621',
    'medium green': '#4C9A4C',
    'gray blue': '#7A8B99',
    'grey blue': '#7A8B99',
    'klein blue': '#002FA7',
    'dark brown': '#3B2415',
    'gray coffee': '#6E6259',
    'grey coffee': '#6E6259',
    'red': '#C1272D',
    'light blue': '#A9CCE3',
    'oat gray': '#C9C0B3',
    'oat grey': '#C9C0B3',
    'pink': '#E8A0BF',
    'medium blue': '#3B6FA0',
    'white': '#F5F5F2',
    'jeans blue': '#4A6B8A',
    'flower gray': '#B8B2AC',
    'flower grey': '#B8B2AC',
    'light gray': '#D3D3D3',
    'light grey': '#D3D3D3',
    'gray apricot': '#C9A99A',
    'grey apricot': '#C9A99A',
    'dark purple': '#3B1F3D'
  };

  var OPTION_NAMES = ['color', 'colour'];

  function hexFor(name) {
    if (!name) return null;
    var key = name.trim().toLowerCase();
    return COLOR_MAP[key] || null;
  }

  function isColorFieldset(fieldset) {
    var legend = fieldset.querySelector('legend');
    var legendText = legend ? legend.textContent.trim().toLowerCase() : '';
    if (OPTION_NAMES.indexOf(legendText) !== -1) return true;
    var input = fieldset.querySelector('input[data-option-name]');
    if (input) {
      var optName = (input.getAttribute('data-option-name') || '').trim().toLowerCase();
      if (OPTION_NAMES.indexOf(optName) !== -1) return true;
    }
    return false;
  }

  function hexToRgba(hex, alpha) {
    var clean = hex.replace('#', '');
    if (clean.length === 3) {
      clean = clean[0] + clean[0] + clean[1] + clean[1] + clean[2] + clean[2];
    }
    var r = parseInt(clean.substring(0, 2), 16);
    var g = parseInt(clean.substring(2, 4), 16);
    var b = parseInt(clean.substring(4, 6), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
  }

  function buildSwatch(hex) {
    var span = document.createElement('span');
    span.className = 'huggable-swatch';
    span.setAttribute('data-huggable-color', hex);
    span.style.backgroundColor = hex;
    span.style.setProperty('--huggable-halo', hexToRgba(hex, 0.35));
    span.setAttribute('aria-hidden', 'true');
    return span;
  }

  var INLINE_PROPS = ['width', 'min-width', 'max-width', 'flex', 'flex-basis', 'flex-grow', 'padding', 'padding-inline', 'padding-left', 'padding-right', 'margin', 'height', 'min-height'];

  function stripInlineSizing(el) {
    for (var i = 0; i < INLINE_PROPS.length; i++) {
      el.style.removeProperty(INLINE_PROPS[i]);
    }
  }

  function enhanceLabel(label) {
    var textSpan = label.querySelector('[data-key="variant-option-text"], .variant-option__button-label__text');
    var input = label.querySelector('input[type="radio"]');
    if (!textSpan || !input) return;

    var hex = hexFor(textSpan.textContent);
    if (!hex) return;

    textSpan.classList.add('huggable-sr-only');
    stripInlineSizing(label);

    var existingSwatch = label.querySelector('.huggable-swatch');
    if (!existingSwatch) {
      label.insertBefore(buildSwatch(hex), textSpan);
    }

    label.classList.toggle('huggable-selected', input.checked);
  }

  function getOrCreateRow(fieldset) {
    var row = fieldset.querySelector(':scope > .huggable-swatch-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'huggable-swatch-row';
      fieldset.appendChild(row);
    }
    return row;
  }

  function enhanceFieldset(fieldset) {
    if (!isColorFieldset(fieldset)) return;
    fieldset.classList.add('huggable-swatch-fieldset');
    stripInlineSizing(fieldset);

    var row = getOrCreateRow(fieldset);

    var strayLabels = fieldset.querySelectorAll(':scope > .variant-option__button-label');
    strayLabels.forEach(function (label) {
      row.appendChild(label);
    });

    var labels = row.querySelectorAll('.variant-option__button-label');
    labels.forEach(enhanceLabel);

    if (!fieldset.dataset.huggableListenerAttached) {
      fieldset.addEventListener('change', function () {
        var labels = fieldset.querySelectorAll('.variant-option__button-label');
        labels.forEach(function (label) {
          var input = label.querySelector('input[type="radio"]');
          if (input) label.classList.toggle('huggable-selected', input.checked);
        });
        scheduleScan();
        setTimeout(scheduleScan, 150);
        setTimeout(scheduleScan, 500);
      });
      fieldset.dataset.huggableListenerAttached = '1';
    }
  }

  function scan(root) {
    var scope = root || document;
    var fieldsets = scope.querySelectorAll ? scope.querySelectorAll('fieldset.variant-option') : [];
    fieldsets.forEach(enhanceFieldset);
  }

  var scanScheduled = false;
  function scheduleScan() {
    if (scanScheduled) return;
    scanScheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scanScheduled = false;
      scan(document);
    });
  }

  function init() {
    scan(document);

    var observer = new MutationObserver(function () {
      scheduleScan();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
